import React from 'react';
import '../css/recommendedVideos.css';
import VideoCard from './VideoCard';

export default function RecommendedVideos() {
  return (
    <div className="recommendedVideos">
      <h1>Recommended Videos</h1>
      <div className="recommendedVideos_videos">
      <VideoCard 
      image="https://i.ytimg.com/vi/XzJ1WnFTVds/maxresdefault.jpg"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRU1Pj9YW7m4LfiSEaPp8XAv_E-h5bUajmy7Q&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQIvBwMQtimLsmfRJEeJgM2RLYySAEVxoItdw&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTmdw4kpU3Nx8RWfMKUAX3lfSW4K0rpurOh_g&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQtVQ3o2DKnx-J2HxLHkIioTAvRYdhPlWxtIQ&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTeLvsQcXEuGlSdTtDG4GQ3IrDhF5f4TopA-g&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTivkv9Gcw7giuni4eoIjWBMPg2J5eJRTvSeg&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRrLY7JqE_435WPfvcHTeYOcqI_KxFTuHcMyg&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSGRxFtqR3bpxOgGBoKOO28sBQmAHCeuhuU8A&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQDEEhkM40AH--Btr8Y2WeqSE4ESxcNBRAoCA&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTy4aRTZv4sQZmvTG75ITcptM25a1NFjKEu9g&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      <VideoCard 
      image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTCZ3pBKi0B5DwBt3Luni0MQaFKfQbAacqsgQ&usqp=CAU"
      title="Become a web developer"
      channel="John Doe"
      views="2.3M Views"
      timestamp="3 days ago"
      channelImage 
      />
      </div>
    </div>
  );
}
